module.exports = __webpack_public_path__ + "img/feature_e01.114c6d31.svg";